import React from 'react';

function SvgEchIconSocialMediaFacebook2White(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <defs>
        <style>{'.cls-1{fill:#fff;}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M58.73,51.77l1.13-7.37H52.78V39.61c0-2,1-4,4.16-4h3.22V29.35a39.11,39.11,0,0,0-5.71-.5c-5.83,0-9.64,3.53-9.64,9.93V44.4H38.33v7.37h6.48V69.6h8V51.77Z"
      />
    </svg>
  );
}
export default SvgEchIconSocialMediaFacebook2White;
